export const DATE_FORMATS = {
  MONTH_DAY: 'MMMM D',
  MONTH_DAY_YYYY: 'MMMM D, YYYY',
  D_MMM_YYYY: 'D MMM YYYY',
  MMM_D: 'MMM D',
  MMM: 'MMM',
  MONTH: 'MMMM',
  YYYY_MM_DD_DASHED: 'YYYY-MM-DD',
  DD_MM_YYYY_SLASH: 'DD/MM/YYYY',
  DD_MM_YYYY_DOT: 'DD.MM.YYYY',
} as const;

export type IDateFormats = (typeof DATE_FORMATS)[keyof typeof DATE_FORMATS];
